// extracted by mini-css-extract-plugin
module.exports = {"navitem":"navigationitem_navitem__1ZTEP","active":"navigationitem_active__3y6ys"};